<script>
import Vue from 'vue';

export default {
    name: 'DynamicComponent',

    props: {
        content: { required: true, type: String }
    },

    methods: {
        editItem: function editItem(key) {
            this.$emit('editPopup', key);
        },
    },

    render(h) {
        return h(Vue.compile(`<div class="DynamicContent">${this.content}</div>`));
    },

    created() {
        window.editItem = this.editItem;
    },
};
</script>
<style>
.underline {
    text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/content/DynamicContent.vue